module.exports = __webpack_public_path__ + "static/img/lactose.fb57c7f3.jpg";